import { ImageViewerLocal } from "@/components/ImageViewerLocal";
import { safeRealName } from "@/utils/safe";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { Icon } from "@/components/Icon";
type Info = {
  receiptCode: string;
  province: string;
  city: string;
  usdtAddress: string;
  realName: string;
  digitalAddress: string
};
type AlipayItemProps = {
  item: Info;
  index: number;
};

export const DigitalRMBItem = ({ item, index }: AlipayItemProps) => {
  return (
    <div className={classNames(styles.card)}>
      <div className={styles.item_icon}>
        <Icon name={'digital_rmb'} size={'0.24rem'}/>
      </div>

      <div className={styles.item_text}>
        <div>数字人民币收款地址：{safeRealName(item.digitalAddress)}</div>
        <div>姓名：{safeRealName(item.realName)}</div>
      </div>
    </div>
  );
};
